const USERS_KEY = 'hsl_users';
const ORDERS_KEY = 'hsl_orders';

export function readJson<T>(key: string, fallback: T): T {
  try {
    const data = localStorage.getItem(key);
    return data ? (JSON.parse(data) as T) : fallback;
  } catch {
    return fallback;
  }
}

export function writeJson<T>(key: string, value: T) {
  localStorage.setItem(key, JSON.stringify(value));
}

export const mockStorageKeys = {
  users: USERS_KEY,
  orders: ORDERS_KEY,
  nextOrderNumber: 'hsl_next_order_number',
  addresses: 'hsl_addresses',
  products: 'hsl_products',
  emailVerificationTokens: 'hsl_email_verification_tokens',
  passwordResetTokens: 'hsl_password_reset_tokens',
} as const;

export function delay(ms = 400) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function createMockToken(userId: string) {
  return `mock.${userId}.${Date.now()}`;
}

export function parseMockToken(token: string): string | null {
  if (!token.startsWith('mock.')) return null;
  const parts = token.split('.');
  return parts[1] ?? null;
}
